// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FeY-u","right":"styles_right__2wxSc"};